import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import CookieConsent from "@/components/public/CookieConsent";
import { publicApi } from "@/lib/api";

export default function PublicLayout() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    publicApi.getSettings().then(setSettings).catch(() => setSettings(null));
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-transparent text-brand-white minga-pattern-bg">
      <Header />
      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
      <CookieConsent />
    </div>
  );
}
